// NOTE: keep synced with variables.scss
export const colorPrimary = '#EB5C0B';
